import { api } from "./client";

/**
 * Tải file do API sinh ra (nút "Xuất báo cáo"). Không dùng thẻ <a href> trực tiếp
 * được vì request cần header Authorization, nên phải tải qua axios rồi tạo blob URL.
 */
export async function downloadFile(
  path: string,
  params: Record<string, string | number | undefined>,
  fallbackName: string,
): Promise<void> {
  const clean = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== ""),
  );
  const res = await api.get(path, { params: clean, responseType: "blob" });

  // Ưu tiên tên file server đặt trong Content-Disposition.
  const disposition = String(res.headers?.["content-disposition"] ?? "");
  const match = /filename="?([^";]+)"?/i.exec(disposition);
  const filename = match?.[1] ?? fallbackName;

  const url = URL.createObjectURL(res.data as Blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1500);
}
